import { round } from 'lodash';
import React from 'react';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { PortRow } from './templates/PortRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
};
export const PressureLossRow = ({ manifold }: Props) => (
  <PortRow
    name="kPa per Port" // We display the pressureLossPerCoil even though the heading says per Port
    manifold={manifold}
    getValue={room =>
      room.heatLossAndHeatOutput == null ? '' : round(room.heatLossAndHeatOutput.pressureLossPerCoil, 2)
    }
  />
);
